import './styles.css';
import type { UspNode } from 'data-layer';
import { Usp, type UspItemProps } from '@pixum/usp';
import { UspImage } from './UpsImage';
import { slugifyString } from 'utils';
import type { DeviceOrientedComponentProps } from '../../types';

interface UspCollectionProps extends DeviceOrientedComponentProps {
  uspList?: UspNode[];
}

export function UspCollection(props: UspCollectionProps) {
  const { uspList = [], device } = props;
  const transformedUspList: UspItemProps[] = uspList.map(usp => ({
    headline: usp.headline ?? '',
    labelledByHeadline: slugifyString(usp.headline) ?? '',
    subheadline: usp.subHeadline ?? '',
    image: <UspImage image={usp.image} device={device} />,
  }));

  return <Usp uspList={transformedUspList} />;
}
